import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import classNames from 'classnames';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ShowHideDialog from '../../components/molecules/ConfirmDialog';
import DeleteMenuEventDialog from '../../components/molecules/DeleteMenuEventDialog';
import {
  getGochiMenus,
  getGochiMenuDetail,
  deleteGochiMenu,
  showHideGochiMenu,
  changeShashokuOption,
  addMenuEvent,
  deleteMenuEvent,
  getMenuImageSample,
  GET_MENU_IMAGE_SUCCESS
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import ContentDialog from '../../components/molecules/ContentDialog';
import GochiMenuTableBodyGroup from '../../components/molecules/GochiMenuTableBodyGroup';
import GochiMenuTableHeadGroup from '../../components/molecules/GochiMenuTableHeadGroup';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import GochiMenuDetailGroup from './GochiMenuDetailGroup';
import GochiMenuEditGroup from './GochiMenuEditGroup';
import GochiMenuDetailGroupV2 from './GochiMenuDetailGroupV2';
import usageTypes from '../../constants/UsageType';
import GochiMenuEditGroupV2 from './GochiMenuEditGroupV2';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  modalV2: {
    maxWidth: 1153
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.menus,
      totalCount: state.gochiMenus.totalCount,
      offset: state.gochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getGochiMenuDetail,
          deleteGochiMenu,
          showHideGochiMenu,
          changeShashokuOption,
          addMenuEvent,
          deleteMenuEvent,
          getMenuImageSample
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDetailNewModal', 'updateOpenDetailNewModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditNew', 'updateOpenEditNew', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('deleteNote', 'setDeleteNote', ''),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuChildType', 'setMenuChildType', 0),
  withState('comboMenu', 'setComboMenu', 0),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', 0),
  withState('menuName', 'setMenuName', ''),
  withState('price', 'setPrice', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('expiration', 'setExpiration', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('taxTypeStr', 'setTaxTypeStr', '外税'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('reducedTaxTypeStr', 'setReducedTaxTypeStr', '対象外'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 15),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('openShowHide', 'updateOpenShowHide', false),
  withState('showHideNote', 'setShowHideNote', false),
  withState('showHide', 'setShowHide', 1),
  withState('shashokuOptionStr', 'setShashokuOptionStr', ''),
  withState('openDeleteMenuEvent', 'updateOpenDeleteMenuEvent', false),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuSituationNames', 'setMenuSituationNames', ''),
  withState('subscription', 'setSubscription', ''),
  withState('subscriptionInterval', 'setSubscriptionInterval', ''),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('menuUserTargetNames', 'setMenuUserTargetNames', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('usageType', 'setUsageType', 0),
  withState('shopGochiRestriction', 'setShopGochiRestriction', ''),
  withState('menuImageSampleList', 'setMenuImageSampleList', []),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    progress,
    searchKey,
    page,
    selectedPage,
    handleChangePage,
    menus,
    totalCount,
    name,
    openDetailModal,
    updateOpenDetailModal,
    openDetailNewModal,
    updateOpenDetailNewModal,
    openDelete,
    updateOpenDelete,
    deleteNote,
    setDeleteNote,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    openEdit,
    updateOpenEdit,
    openEditNew,
    updateOpenEditNew,
    openEditConfirm,
    updateOpenEditConfirm,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    updateIsDeleteSuccess,
    resultMessage,
    setResultMessage,
    menuChildType,
    setMenuChildType,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    shopId,
    setShopId,
    shopName,
    setShopName,
    menuId,
    setMenuId,
    menuName,
    setMenuName,
    comboMenu,
    setComboMenu,
    price,
    setPrice,
    priceCombo,
    setPriceCombo,
    quantityRelease,
    setQuantityRelease,
    quantityPromotion,
    setQuantityPromotion,
    usageLimit,
    setUsageLimit,
    description,
    setDescription,
    promotionDescription,
    setPromotionDescription,
    expiration,
    setExpiration,
    expirationEndDate,
    setExpirationEndDate,
    taxType,
    setTaxType,
    taxTypeStr,
    setTaxTypeStr,
    reducedTaxType,
    setReducedTaxType,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxTypeStr,
    setReducedTaxTypeStr,
    setSubscription,
    setSubscriptionInterval,
    setSubscriptionIntervalCount,
    subscription,
    subscriptionInterval,
    subscriptionIntervalCount,
    tags,
    setTags,
    tagStr,
    setTagStr,
    image,
    setImage,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    order,
    orderBy,
    handleRequestSort,
    openShowHide,
    updateOpenShowHide,
    showHideNote,
    setShowHideNote,
    showHide,
    setShowHide,
    openDeleteMenuEvent,
    updateOpenDeleteMenuEvent,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    setFullMessage,
    setShashokuOptionStr,
    shashokuOptionStr,
    setRowsPerPage,
    otherLanguages,
    setOtherLanguages,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuSituationIds,
    setmenuSituationIds,
    menuSituationNames,
    setMenuSituationNames,
    menuUserTargetIds,
    setmenuUserTargetIds,
    menuUserTargetNames,
    setMenuUserTargetNames,
    menuLimitTotal,
    setMenuLimitTotal,
    isFukuoka,
    usageType,
    setUsageType,
    shopGochiRestriction,
    setShopGochiRestriction,
    menuImageSampleList,
    setMenuImageSampleList
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const paramShowHide = {
      showHide
    };
    const detail = {
      menuChildType,
      groupId,
      groupName,
      shopId,
      shopName,
      menuId,
      menuName,
      price,
      description,
      comboMenu,
      priceCombo,
      quantityRelease,
      quantityPromotion,
      promotionDescription,
      subscriptionIntervalCount,
      subscriptionInterval,
      subscription,
      usageLimit,
      expiration,
      expirationEndDate,
      taxType,
      taxTypeStr,
      reducedTaxType,
      reducedTaxCheck,
      reducedTaxTypeStr,
      tags,
      tagStr,
      image,
      createdAt,
      updatedAt,
      shashokuOptionStr,
      showHide,
      otherLanguages,
      menuGenreName,
      menuSituationNames,
      menuUserTargetNames,
      menuGenreId,
      menuSituationIds,
      menuUserTargetIds,
      menuLimitTotal,
      usageType,
      shopGochiRestriction
    };
    const getGochiMenu = async (id, isEdit) => {
      await actions.getGochiMenuDetail(id).then(async detailData => {
        console.log('DETAIL: ', detailData.payload);
        checkSession(detailData);
        setMenuChildType(detailData.payload.menuChildType);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setShopId(detailData.payload.shopId);
        setShopName(detailData.payload.shopName);
        setMenuId(detailData.payload.menuId);
        setMenuName(detailData.payload.menuName);
        setPrice(detailData.payload.price);
        setDescription(detailData.payload.description);
        setTaxType(detailData.payload.taxType);
        setTaxTypeStr(detailData.payload.taxTypeStr);
        setReducedTaxType(detailData.payload.reducedTaxType);
        setSubscription(detailData.payload.subscription);
        setSubscriptionInterval(detailData.payload.subscriptionInterval);
        setSubscriptionIntervalCount(
          detailData.payload.subscriptionIntervalCount
        );
        setMenuLimitTotal(detailData.payload.menuLimitTotal);
        if (detailData.payload.reducedTaxType === 'REDUCED') {
          setReducedTaxCheck(true);
          setReducedTaxTypeStr('対象');
        } else {
          setReducedTaxCheck(false);
          setReducedTaxTypeStr('対象外');
        }
        setTags(detailData.payload.tags);
        setTagStr(
          detailData.payload.tags
            .map(tag => {
              return `${tag.tagName}`;
            })
            .join(' ')
        );
        setComboMenu(detailData.payload.menuCombo);
        setPriceCombo(detailData.payload.priceCombo);
        setQuantityRelease(detailData.payload.quantity);
        setQuantityPromotion(detailData.payload.quantityFree);
        setPromotionDescription(detailData.payload.quantityFreeDes);
        setUsageLimit(detailData.payload.numberUsePerDay);
        setExpiration(detailData.payload.expiration);
        setExpirationEndDate(detailData.payload.expirationEndDate);
        setImage(detailData.payload.image);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        console.log('PAYLOAD: ', detailData.payload);
        const shashokuOptionArr = [];
        if (detailData.payload.gochimeshiFlag === 1) {
          shashokuOptionArr.push('ごちめし（さきめし含む）');
        }
        if (detailData.payload.shashokuFlag === 1) {
          shashokuOptionArr.push('社食ごちめし');
        }
        if (detailData.payload.gochiKidFlag === 1) {
          shashokuOptionArr.push('こどもごちめし');
        }
        setShashokuOptionStr(shashokuOptionArr.join(', '));
        setShowHide(detailData.payload.showHide);
        setOtherLanguages(detailData.payload.otherLanguages);

        if (detailData.payload.menuGenreId) {
          setMenuGenreId(detailData.payload.menuGenreId);
          setMenuGenreName(
            menuGenre.find(
              genre =>
                genre.menuGenreId.toString() ===
                detailData.payload.menuGenreId.toString()
            ).menuGenreName
          );
        } else {
          setMenuGenreId(null);
          setMenuGenreName('');
        }

        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const userTargetNames = [];
          detailData.payload.menuUserTargetIds.forEach(userTargetId => {
            const userTargetname = menuUserTarget.find(
              userTarget =>
                userTarget.menuUserTargetId.toString() ===
                userTargetId.toString()
            ).name;
            userTargetNames.push(userTargetname);
          });
          setmenuUserTargetIds(detailData.payload.menuUserTargetIds);
          setMenuUserTargetNames(userTargetNames.join(', '));
        } else {
          setmenuUserTargetIds([]);
          setMenuUserTargetNames('');
        }
        if (
          detailData.payload.menuSituationIds &&
          detailData.payload.menuSituationIds.length
        ) {
          const situationNames = [];
          detailData.payload.menuSituationIds.forEach(situationId => {
            const situationName = menuSituation.find(
              situation =>
                situation.menuSituationId.toString() === situationId.toString()
            ).menuSituationName;
            situationNames.push(situationName);
          });
          setmenuSituationIds(detailData.payload.menuSituationIds);
          setMenuSituationNames(situationNames.join(', '));
        } else {
          setmenuSituationIds([]);
          setMenuSituationNames('');
        }

        if (!isFukuoka) {
          setUsageType(detailData.payload.usageType);
          setShopGochiRestriction(detailData.payload.gochiRestriction);
          if (isEdit && detailData.payload.usageType === USAGE_TYPE_MENU) {
            const response = await actions.getMenuImageSample();
            if (response.type === GET_MENU_IMAGE_SUCCESS) {
              setMenuImageSampleList(response.payload);
            } else {
              setMenuImageSampleList([]);
            }
          }
        }
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiMenu(params.id, false)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          if (isFukuoka) {
            updateOpenDetailModal(true);
          } else {
            updateOpenDetailNewModal(true);
          }
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = id => {
      let readonly = false;
      menus
        .filter(item => item.menuId === id)
        .forEach(menu => {
          if (menu.readonly) {
            readonly = true;
          }
        });
      if (readonly) {
        const msg =
          'このメニューは未使用の「ごち」が残っているため、編集できません。';
        setFullMessage(msg);
        updateOpenFullMessage(true);
      } else {
        progress.updateLoading(true);
        progress.updateOpenProgress(true);
        getGochiMenu(id, true)
          .then(() => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
            if (isFukuoka) {
              updateOpenEdit(true);
            } else {
              updateOpenEditNew(true);
            }
          })
          .catch(() => {
            progress.updateOpenProgress(false);
            progress.updateLoading(false);
          });
      }
    };
    const deleteOpenAction = id => {
      let readonly = false;
      let note = '';
      menus
        .filter(item => item.menuId === id)
        .forEach(menu => {
          if (menu.readonly) {
            readonly = true;
          }
          if (menu.gochiKidFlag === 1) {
            note = '※当メニューは、こどもごちめし利用対象メニューです。';
          }
        });
      if (readonly) {
        const msg =
          'このメニューは未使用の「ごち」が残っているため、削除できません。\nメニューとして表示したくない場合は「非表示」を選択ください。';
        setFullMessage(msg);
        updateOpenFullMessage(true);
      } else {
        updateOpenDelete(true);
        setTargetRowId(id);
        setDeleteNote(note);
      }
    };
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedMenu = await actions
        .deleteGochiMenu(targetRowId)
        .then(data => checkSession(data));
      if (deletedMenu.type === 'DELETE_GOCHI_MENU_SUCCESS') {
        updateIsDeleteSuccess(true);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('削除に失敗しました。');
        updateLoading(false);
      }
    };

    const showHideOpenAction = params => {
      updateOpenShowHide(true);
      if (params.showHide) {
        setShowHide(0);
      } else {
        setShowHide(1);
      }
      setTargetRowId(params.id);
      const arr = [];
      if (params.gochimeshiFlag === 1) {
        arr.push('「ごちめし（さきめし含む）」');
      }
      if (params.shashokuFlag === 1) {
        arr.push('「社食ごちめし」');
      }
      if (params.gochiKidFlag === 1) {
        arr.push('「こどもごちめし」');
      }
      if (arr.length) {
        setShowHideNote(`※${arr.join('と')}で、メニューが非公開になります。`);
      } else {
        setShowHideNote('');
      }
    };
    const cancelShowHideAction = () => updateOpenShowHide(false);
    const showHideAction = async () => {
      updateLoading(true);
      const showHidedMenu = await actions
        .showHideGochiMenu(targetRowId, paramShowHide)
        .then(data => checkSession(data));
      if (showHidedMenu.type === 'SHOW_HIDE_GOCHI_MENU_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
        updateOpenShowHide(false);
      } else {
        updateLoading(false);
        updateOpenShowHide(false);
      }
    };
    const changeShashokuOptionAction = async params => {
      console.log('CHANGE SHASHOKU OPTION: ', params);
      updateLoading(true);
      const shashokuOn = params.shashokuFlag;
      const gochimeshiOn = params.gochimeshiFlag;
      const changeResponse = await actions
        .changeShashokuOption(params.menuId, shashokuOn, gochimeshiOn)
        .then(data => checkSession(data));
      if (changeResponse.type === 'CHANGE_SHASHOKU_OPTION_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
      } else {
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    const addMenuEventAction = async params => {
      console.log('params=========', params);
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      const dataResponse = await actions
        .addMenuEvent(params)
        .then(data => checkSession(data));
      if (dataResponse.type === 'ADD_MENU_EVENT_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        progress.updateLoading(false);
        progress.updateOpenProgress(false);
      } else {
        progress.updateLoading(false);
        progress.updateOpenProgress(false);
      }
    };

    const deleteMenuEventOpenAction = id => {
      updateOpenDeleteMenuEvent(true);
      setTargetRowId(id);
    };
    const deleteMenuEventAction = async () => {
      updateLoading(true);
      const updatedMenu = await actions
        .deleteMenuEvent(targetRowId)
        .then(data => checkSession(data));
      if (updatedMenu.type === 'DELETE_MENU_EVENT_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
        updateOpenDeleteMenuEvent(false);
      } else {
        updateLoading(false);
        updateOpenDeleteMenuEvent(false);
      }
    };
    const cancelDeleteMenuEventAction = () => updateOpenDeleteMenuEvent(false);
    return (
      <div>
        <ExPaginationGroup
          count={
            totalCount % rowsPerPage > 0
              ? Math.floor(totalCount / rowsPerPage) + 1
              : Math.floor(totalCount / rowsPerPage)
          }
          selectedPage={selectedPage}
          handleChangePage={handleChangePage}
          limit={rowsPerPage}
          totalCount={totalCount}
          setLimit={setRowsPerPage}
          hideRowsPerPage
        />
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiMenuTableHeadGroup
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
              isFukuoka={isFukuoka}
            />
            <GochiMenuTableBodyGroup
              menus={menus}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenDetailModal={updateOpenDetailModal}
              detailOpenAction={detailOpenAction}
              editOpenAction={editOpenAction}
              showHideOpenAction={showHideOpenAction}
              deleteOpenAction={deleteOpenAction}
              setTargetRowId={setTargetRowId}
              roles={roles}
              order={order}
              orderBy={orderBy}
              changeShashokuOptionAction={changeShashokuOptionAction}
              deleteMenuEventOpenAction={deleteMenuEventOpenAction}
              addMenuEventAction={addMenuEventAction}
              isFukuoka={isFukuoka}
            />
          </Table>
        </div>
        <div>
          <ExPaginationGroup
            count={
              totalCount % rowsPerPage > 0
                ? Math.floor(totalCount / rowsPerPage) + 1
                : Math.floor(totalCount / rowsPerPage)
            }
            selectedPage={selectedPage}
            handleChangePage={handleChangePage}
            limit={rowsPerPage}
            totalCount={totalCount}
            hideRowsPerPage
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modal}
        >
          <GochiMenuDetailGroup
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
            isFukuoka={isFukuoka}
          />
        </Modal>
        <Modal
          open={openDetailNewModal}
          onClose={() => {
            updateOpenDetailNewModal(false);
          }}
          className={classNames(classes.modal, classes.modalV2)}
        >
          <GochiMenuDetailGroupV2
            updateOpenDetailModal={updateOpenDetailNewModal}
            detail={detail}
            menuGenre={menuGenre}
          />
        </Modal>
        <Modal open={openEdit} className={classes.modal}>
          <GochiMenuEditGroup
            name={name}
            roles={roles}
            openEditConfirm={openEditConfirm}
            updateOpenEdit={updateOpenEdit}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
            menuGenre={menuGenre}
            menuSituation={menuSituation}
            menuUserTarget={menuUserTarget}
            isFukuoka={isFukuoka}
          />
        </Modal>
        <Modal
          open={openEditNew}
          className={classNames(classes.modal, classes.modalV2)}
        >
          <GochiMenuEditGroupV2
            name={name}
            updateOpenEdit={updateOpenEditNew}
            editInput={detail}
            searchKey={searchKey}
            menuGenre={menuGenre}
            menuImageSampleList={menuImageSampleList}
          />
        </Modal>
        <ShowHideDialog
          openConfirm={openShowHide}
          cancelAction={cancelShowHideAction}
          updateOpenConfirm={updateOpenShowHide}
          okAction={showHideAction}
          targetRowId={targetRowId}
          message="表示状況を変更します。よろしいでしょうか？"
          note={showHideNote}
        />
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target={isFukuoka ? 'コース' : 'メニュー'}
          deleteNote={deleteNote}
        />
        <DeleteMenuEventDialog
          openDelete={openDeleteMenuEvent}
          updateOpenDelete={updateOpenDeleteMenuEvent}
          cancelAction={cancelDeleteMenuEventAction}
          deleteAction={deleteMenuEventAction}
          targetRowId={targetRowId}
          target="メニューイベント"
        />
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
